webpackJsonp([231608221292675],{

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.apiRunner = apiRunner;
	exports.apiRunnerAsync = apiRunnerAsync;
	var plugins = [{
	  plugin: __webpack_require__(722),
	  options: { "plugins": [] }
	}, {
	  plugin: __webpack_require__(449),
	  options: { "plugins": [], "google": { "trackingId": "UA-36046017-2", "anonymize": false }, "facebook": { "pixelId": "1163057663706515" }, "linkedIn": { "partnerId": "154514" } }
	}, {
	  plugin: __webpack_require__(448),
	  options: { "plugins": [] }
	}];
	// During bootstrap, we write requires at top of this file which looks
	// basically like:
	// var plugins = [
	//   require('/path/to/plugin1/gatsby-browser.js'),
	//   require('/path/to/plugin2/gatsby-browser.js'),
	// ]
	
	function apiRunner(api, args, defaultReturn) {
	  var results = plugins.map(function (plugin) {
	    if (plugin.plugin[api]) {
	      var result = plugin.plugin[api](args, plugin.options);
	      return result;
	    }
	  });
	
	  // Filter out undefined results.
	  results = results.filter(function (result) {
	    return typeof result !== 'undefined';
	  });
	
	  if (results.length > 0) {
	    return results;
	  } else if (defaultReturn) {
	    return [defaultReturn];
	  } else {
	    return [];
	  }
	}
	
	function apiRunnerAsync(api, args, defaultReturn) {
	  return plugins.reduce(function (previous, next) {
	    return next.plugin[api] ? previous.then(function () {
	      return next.plugin[api](args, next.options);
	    }) : previous;
	  }, Promise.resolve());
	}

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _exports$json;
	
	// prefer default export if available
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	
	exports.components = {
	  "component---src-templates-chapter-js": __webpack_require__(647),
	  "component---src-templates-article-js": __webpack_require__(646),
	  "component---src-pages-404-js": __webpack_require__(637),
	  "component---src-pages-cookies-js": __webpack_require__(639),
	  "component---src-pages-index-js": __webpack_require__(642),
	  "component---src-pages-terms-js": __webpack_require__(645),
	  "component---src-pages-all-charts-index-js": __webpack_require__(638),
	  "component---src-pages-filter-article-js": __webpack_require__(640),
	  "component---src-pages-filter-index-js": __webpack_require__(641),
	  "component---src-pages-saved-article-js": __webpack_require__(643),
	  "component---src-pages-saved-index-js": __webpack_require__(644)
	};
	
	exports.json = (_exports$json = {
	  "layout-index.json": __webpack_require__(4),
	  "chapter-introduction.json": __webpack_require__(684)
	}, _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-evolving-europe.json"] = __webpack_require__(677), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-talent.json"] = __webpack_require__(706), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-community.json"] = __webpack_require__(662), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-capital-flows.json"] = __webpack_require__(656), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-deep-tech.json"] = __webpack_require__(671), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-corporate.json"] = __webpack_require__(666), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-regulation.json"] = __webpack_require__(699), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-success-stories-exits.json"] = __webpack_require__(702), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-mythbusting.json"] = __webpack_require__(695), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-whats-next.json"] = __webpack_require__(713), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-appendix.json"] = __webpack_require__(653), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-acknowledgements.json"] = __webpack_require__(651), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-introduction-article-about-report.json"] = __webpack_require__(686), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-introduction-article-how-use-site.json"] = __webpack_require__(691), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-introduction-article-about-atomico.json"] = __webpack_require__(685), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-introduction-article-about-slush.json"] = __webpack_require__(688), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-introduction-article-data-partners.json"] = __webpack_require__(689), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-introduction-article-thought-leaders.json"] = __webpack_require__(693), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-introduction-article-distribution-partners.json"] = __webpack_require__(690), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-introduction-article-word-from-orrick.json"] = __webpack_require__(694), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-introduction-article-about-silicon-valley-bank.json"] = __webpack_require__(687), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-introduction-article-studio-lovelock-website-design.json"] = __webpack_require__(692), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-evolving-europe-article-its-been-busy-year-european-tech.json"] = __webpack_require__(682), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-evolving-europe-article-europe-remains-bullish-about-future.json"] = __webpack_require__(678), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-evolving-europe-article-macro-events-europes-tech-ecosystem.json"] = __webpack_require__(683), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-evolving-europe-article-european-entrepreneurs-worlds-biggest-problems.json"] = __webpack_require__(679), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-evolving-europe-article-european-tech-continues-diversify-geographically.json"] = __webpack_require__(680), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-evolving-europe-article-gender-diversity-problem.json"] = __webpack_require__(681), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-talent-article-strong-pipeline-world-class-talent.json"] = __webpack_require__(710), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-talent-article-europes-tech-workforce-and-dev-population-booming.json"] = __webpack_require__(708), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-talent-article-big-tech-giants-are-growing-presence.json"] = __webpack_require__(707), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-talent-article-tech-talent-movement-in-europe.json"] = __webpack_require__(711), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-talent-article-uk-larger-share-outbound-tech-talent-migration.json"] = __webpack_require__(712), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-talent-article-portrait-european-founder.json"] = __webpack_require__(709), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-community-article-growing-and-highly-engaged-tech-communities.json"] = __webpack_require__(665), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-community-article-every-european-city-becoming-tech-hub.json"] = __webpack_require__(664), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-community-article-capital-founder-mobility-links-europes-hubs.json"] = __webpack_require__(663), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-capital-flows-article-another-record-year-european-tech-investment.json"] = __webpack_require__(657), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-capital-flows-article-deep-dive-european-tech.json"] = __webpack_require__(659), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-capital-flows-article-strength-europes-tech-ecosystem-investors.json"] = __webpack_require__(661), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-capital-flows-article-european-vcs-deliver-strong-year-fundraising.json"] = __webpack_require__(660), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-capital-flows-article-attract-more-institutional-investors.json"] = __webpack_require__(658), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-deep-tech-article-european-deep-tech-seize-global-opportunities.json"] = __webpack_require__(675), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-deep-tech-article-ai-crypto-major-opportunity-europe.json"] = __webpack_require__(672), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-deep-tech-article-europes-engineering-engaging-data-science.json"] = __webpack_require__(676), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-deep-tech-article-europe-key-role-crypto-space.json"] = __webpack_require__(674), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-deep-tech-article-europe-front-and-centre-race-in-ico-boom.json"] = __webpack_require__(673), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-corporate-article-european-tech-forge-ties-traditional-industry.json"] = __webpack_require__(667), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-corporate-article-europes-corporates-battling-defend-trillions-value.json"] = __webpack_require__(668), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-corporate-article-patterns-flow-talent-tech-traditional-industry.json"] = __webpack_require__(670), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-corporate-article-europes-traditional-incumbents-hungry.json"] = __webpack_require__(669), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-regulation-article-regulation-viewed-barrier-scaling-european-tech.json"] = __webpack_require__(701), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-regulation-article-regulation-to-become-strategic-advantage.json"] = __webpack_require__(700), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-success-stories-exits-article-europes-billion-dollar-success-stories.json"] = __webpack_require__(705), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-success-stories-exits-article-europe-track-another-75-exit-value-2017.json"] = __webpack_require__(703), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-success-stories-exits-article-european-tech-another-strong-year-ipos.json"] = __webpack_require__(704), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-mythbusting-article-european-venture-delivers-returns.json"] = __webpack_require__(698), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-mythbusting-article-european-investors-localised.json"] = __webpack_require__(696), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-mythbusting-article-european-public-market-investors-get-tech.json"] = __webpack_require__(697), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-whats-next-article-predictions-european-tech-2018.json"] = __webpack_require__(714), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-appendix-article-survey-respondents.json"] = __webpack_require__(655), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-appendix-article-more-about-our-data-partners.json"] = __webpack_require__(654), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["chapter-acknowledgements-article-contributors.json"] = __webpack_require__(652), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["404.json"] = __webpack_require__(648), _exports$json["layout-blank.json"] = __webpack_require__(316), _exports$json["cookies.json"] = __webpack_require__(715), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["index.json"] = __webpack_require__(718), _exports$json["layout-blank.json"] = __webpack_require__(316), _exports$json["terms.json"] = __webpack_require__(721), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["404-html.json"] = __webpack_require__(649), _exports$json["layout-blank.json"] = __webpack_require__(316), _exports$json["all-charts.json"] = __webpack_require__(650), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["filter-article.json"] = __webpack_require__(717), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["filter.json"] = __webpack_require__(716), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["saved-article.json"] = __webpack_require__(720), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["saved.json"] = __webpack_require__(719), _exports$json);
	
	exports.layouts = {
	  "component---src-layouts-index-js": __webpack_require__(636),
	  "component---src-layouts-blank-js": __webpack_require__(635)
	};

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _loader = __webpack_require__(339);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _emitter = __webpack_require__(243);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _apiRunnerBrowser = __webpack_require__(283);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultLayout = function DefaultLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    children()
	  );
	};
	
	// Pass pathname in as prop.
	// component will try fetching resources. If they exist,
	// will just render, else will render null.
	
	var ComponentRenderer = function (_React$Component) {
	  _inherits(ComponentRenderer, _React$Component);
	
	  function ComponentRenderer(props) {
	    _classCallCheck(this, ComponentRenderer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    var location = props.location;
	
	    // This covers layout for when page not found, especially during production
	    if (!_loader2.default.getPage(location.pathname)) {
	      location = _extends({}, location, _extends({}, location, {
	        pathname: "/404.html"
	      }));
	    }
	
	    _this.state = {
	      location: location,
	      pageResources: _loader2.default.getResourcesForPathname(props.location.pathname)
	    };
	    return _this;
	  }
	
	  ComponentRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    // During development, always pass a component's JSON through so graphql
	    // updates go through.
	    if (false) {
	      if (nextProps && nextProps.pageResources && nextProps.pageResources.json) {
	        this.setState({ pageResources: nextProps.pageResources });
	      }
	    }
	    if (this.state.location.pathname !== nextProps.location.pathname) {
	      var pageResources = _loader2.default.getResourcesForPathname(nextProps.location.pathname);
	      if (!pageResources) {
	        // Page resources won't be set in cases where the browser back button
	        // or forward button is pushed as we can't wait as normal for resources
	        // to load before changing the page.
	        _loader2.default.getResourcesForPathname(nextProps.location.pathname, function (pageResources) {
	          _this2.setState({
	            location: nextProps.location,
	            pageResources: pageResources
	          });
	        });
	      } else {
	        this.setState({
	          location: nextProps.location,
	          pageResources: pageResources
	        });
	      }
	    }
	  };
	
	  ComponentRenderer.prototype.componentDidMount = function componentDidMount() {
	    var _this3 = this;
	
	    // Listen to events so when our page gets updated, we can transition.
	    // This is only useful on delayed transitions as the page will get rendered
	    // without the necessary page resources and then re-render once those come in.
	    _emitter2.default.on("onPostLoadPageResources", function (e) {
	      if (_loader2.default.getPage(_this3.state.location.pathname) && e.page.path === _loader2.default.getPage(_this3.state.location.pathname).path) {
	        _this3.setState({ pageResources: e.pageResources });
	      }
	    });
	  };
	
	  ComponentRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    // 404
	    if (!nextState.pageResources) {
	      return true;
	    }
	
	    // Check if the component or json have changed.
	    if (!this.state.pageResources && nextState.pageResources) {
	      return true;
	    }
	
	    if (this.state.pageResources.component !== nextState.pageResources.component) {
	      return true;
	    }
	
	    if (this.state.pageResources.json !== nextState.pageResources.json) {
	      return true;
	    }
	
	    // Check if location has changed on a page using internal routing
	    // via matchPath configuration.
	    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
	      return true;
	    }
	
	    return false;
	  };
	
	  ComponentRenderer.prototype.render = function render() {
	    var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceComponentRenderer", {
	      props: _extends({}, this.props, { pageResources: this.state.pageResources }),
	      loader: _loader.publicLoader
	    });
	    var replacementComponent = pluginResponses[0];
	    // If page.
	    if (this.props.page) {
	      if (this.state.pageResources) {
	        return replacementComponent || (0, _react.createElement)(this.state.pageResources.component, _extends({
	          key: this.props.location.pathname
	        }, this.props, this.state.pageResources.json));
	      } else {
	        return null;
	      }
	      // If layout.
	    } else if (this.props.layout) {
	      return replacementComponent || (0, _react.createElement)(this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : DefaultLayout, _extends({
	        key: this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : "DefaultLayout"
	      }, this.props));
	    } else {
	      return null;
	    }
	  };
	
	  return ComponentRenderer;
	}(_react2.default.Component);
	
	ComponentRenderer.propTypes = {
	  page: _propTypes2.default.bool,
	  layout: _propTypes2.default.bool,
	  location: _propTypes2.default.object
	};
	
	exports.default = ComponentRenderer;
	module.exports = exports["default"];

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mitt = __webpack_require__(871);
	
	var _mitt2 = _interopRequireDefault(_mitt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emitter = (0, _mitt2.default)();
	module.exports = emitter;

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouterDom = __webpack_require__(223);
	
	var pageCache = {}; // TODO add tests especially for handling prefixed links.
	
	
	module.exports = function (pages) {
	  var pathPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	  return function (rawPathname) {
	    var pathname = decodeURIComponent(rawPathname);
	    // Remove the pathPrefix from the pathname.
	    var trimmedPathname = pathname.slice(pathPrefix.length);
	
	    // Remove any hashfragment
	    if (trimmedPathname.split("#").length > 1) {
	      trimmedPathname = trimmedPathname.split("#").slice(0, -1).join("");
	    }
	
	    // Remove search query
	    if (trimmedPathname.split("?").length > 1) {
	      trimmedPathname = trimmedPathname.split("?").slice(0, -1).join("");
	    }
	
	    if (pageCache[trimmedPathname]) {
	      return pageCache[trimmedPathname];
	    }
	
	    var foundPage = void 0;
	    // Array.prototype.find is not supported in IE so we use this somewhat odd
	    // work around.
	    pages.some(function (page) {
	      if (page.matchPath) {
	        // Try both the path and matchPath
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, { path: page.path }) || (0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.matchPath
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      } else {
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path,
	          exact: true
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	
	        // Finally, try and match request with default document.
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path + "index.html"
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      }
	
	      return false;
	    });
	
	    return foundPage;
	  };
	};

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createBrowserHistory = __webpack_require__(317);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _apiRunnerBrowser = __webpack_require__(283);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceHistory");
	var replacementHistory = pluginResponses[0];
	var history = replacementHistory || (0, _createBrowserHistory2.default)();
	module.exports = history;

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178698757827068, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(732) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(254022195166212, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(733) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(228148681308550, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(734) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(43860634280413, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(735) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(202829962731669, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(736) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(234879362701549, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(737) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(50687577665275, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(738) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(37932264922687, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(739) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(261668533047965, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(740) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(184969935945587, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(741) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(172305783204167, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(742) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(232556285526849, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(743) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(66475578294568, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(744) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(20817802003837, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(745) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(73945982715089, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(746) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(183803572017455, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(747) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(213982066394558, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(748) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(10101848016037, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(749) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(132834773172836, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(750) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(230682420956103, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(751) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(134983609158050, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(752) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(99962976830314, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(753) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(206364414712840, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(754) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(69399652022017, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(755) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(63808167079221, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(756) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(122723012978634, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(757) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(211231130307808, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(758) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(154938799406239, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(759) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(155789725403029, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(760) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(94456187788021, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(761) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(110121263261769, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(762) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(265110195025554, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(763) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(240598397224001, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(764) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(182250441781017, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(765) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(118682649301532, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(766) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(15928522630, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(767) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(266515482197775, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(768) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(110851571568351, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(769) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(275537256487186, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(770) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(237989534483488, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(771) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(269432199373968, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(772) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(28953770623058, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(773) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(145872526001005, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(774) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(275714791101602, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(775) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(259547758925544, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(776) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(82190965919510, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(777) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(4624611269179, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(778) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(243428443481317, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(779) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(235937839415263, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(780) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(27688558919579, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(781) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(269808839995022, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(782) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(38469723913246, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(783) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(9594830519843, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(784) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(146325674595902, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(785) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(253956622898810, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(786) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(66701658571466, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(787) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(16569160828133, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(788) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(49209751152924, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(789) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178062736943999, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(790) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(101660725851681, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(791) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(162051256643042, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(792) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(179689188481263, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(793) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(171011396706565, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(794) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(112751941748675, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(795) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(277479238715965, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(796) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(193807779120720, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(797) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(221523269985284, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(798) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(130775755813921, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(799) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(133703624138323, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(800) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(93386753163734, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(801) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(142629428675168, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(802) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(60335399758886, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(319) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(60335399758886, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(320) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(52067900152682, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(803) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(128310941594850, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(804) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(89335538696419, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(805) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(117852896490765, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(444) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(114276838955818, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(445) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	exports.__esModule = true;
	exports.publicLoader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _findPage = __webpack_require__(442);
	
	var _findPage2 = _interopRequireDefault(_findPage);
	
	var _emitter = __webpack_require__(243);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var findPage = void 0;
	
	var syncRequires = {};
	var asyncRequires = {};
	var pathScriptsCache = {};
	var resourceStrCache = {};
	var resourceCache = {};
	var pages = [];
	// Note we're not actively using the path data atm. There
	// could be future optimizations however around trying to ensure
	// we load all resources for likely-to-be-visited paths.
	var pathArray = [];
	var pathCount = {};
	var resourcesArray = [];
	var resourcesCount = {};
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	var prefetcher = void 0;
	var inInitialRender = true;
	
	// Prefetcher logic
	if (true) {
	  prefetcher = __webpack_require__(446)({
	    getNextQueuedResources: function getNextQueuedResources() {
	      return resourcesArray.slice(-1)[0];
	    },
	    createResourceDownload: function createResourceDownload(resourceName) {
	      fetchResource(resourceName, function () {
	        resourcesArray = resourcesArray.filter(function (r) {
	          return r !== resourceName;
	        });
	        prefetcher.onResourcedFinished(resourceName);
	      });
	    }
	  });
	  _emitter2.default.on("onPreLoadPageResources", function (e) {
	    prefetcher.onPreLoadPageResources(e);
	  });
	  _emitter2.default.on("onPostLoadPageResources", function (e) {
	    prefetcher.onPostLoadPageResources(e);
	  });
	}
	
	var sortResourcesByCount = function sortResourcesByCount(a, b) {
	  if (resourcesCount[a] > resourcesCount[b]) {
	    return 1;
	  } else if (resourcesCount[a] < resourcesCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var sortPagesByCount = function sortPagesByCount(a, b) {
	  if (pathCount[a] > pathCount[b]) {
	    return 1;
	  } else if (pathCount[a] < pathCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var fetchResource = function fetchResource(resourceName) {
	  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	  if (resourceStrCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceStrCache[resourceName]);
	    });
	  } else {
	    // Find resource
	    var resourceFunction = resourceName.slice(0, 12) === "component---" ? asyncRequires.components[resourceName] || asyncRequires.layouts[resourceName] : asyncRequires.json[resourceName];
	
	    // Download the resource
	    resourceFunction(function (err, executeChunk) {
	      resourceStrCache[resourceName] = executeChunk;
	      cb(err, executeChunk);
	    });
	  }
	};
	
	var getResourceModule = function getResourceModule(resourceName, cb) {
	  if (resourceCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceCache[resourceName]);
	    });
	  } else {
	    fetchResource(resourceName, function (err, executeChunk) {
	      if (err) {
	        cb(err);
	      } else {
	        var module = preferDefault(executeChunk());
	        resourceCache[resourceName] = module;
	        cb(err, module);
	      }
	    });
	  }
	};
	
	var mountOrder = 1;
	var queue = {
	  empty: function empty() {
	    pathArray = [];
	    pathCount = {};
	    resourcesCount = {};
	    resourcesArray = [];
	    pages = [];
	  },
	  addPagesArray: function addPagesArray(newPages) {
	    pages = newPages;
	    var pathPrefix = "";
	    if (true) {
	      pathPrefix = ("");
	    }
	    findPage = (0, _findPage2.default)(newPages, pathPrefix);
	  },
	  addDevRequires: function addDevRequires(devRequires) {
	    syncRequires = devRequires;
	  },
	  addProdRequires: function addProdRequires(prodRequires) {
	    asyncRequires = prodRequires;
	  },
	  dequeue: function dequeue(path) {
	    return pathArray.pop();
	  },
	  enqueue: function enqueue(path) {
	    // Check page exists.
	    if (!pages.some(function (p) {
	      return p.path === path;
	    })) {
	      return false;
	    }
	
	    var mountOrderBoost = 1 / mountOrder;
	    mountOrder += 1;
	    // console.log(
	    // `enqueue "${path}", mountOrder: "${mountOrder}, mountOrderBoost: ${mountOrderBoost}`
	    // )
	
	    // Add to path counts.
	    if (!pathCount[path]) {
	      pathCount[path] = 1;
	    } else {
	      pathCount[path] += 1;
	    }
	
	    // Add path to queue.
	    if (!queue.has(path)) {
	      pathArray.unshift(path);
	    }
	
	    // Sort pages by pathCount
	    pathArray.sort(sortPagesByCount);
	
	    // Add resources to queue.
	    var page = findPage(path);
	    if (page.jsonName) {
	      if (!resourcesCount[page.jsonName]) {
	        resourcesCount[page.jsonName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.jsonName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the JSON resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.jsonName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.jsonName);
	      }
	    }
	    if (page.componentChunkName) {
	      if (!resourcesCount[page.componentChunkName]) {
	        resourcesCount[page.componentChunkName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.componentChunkName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the component resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.componentChunkName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.componentChunkName);
	      }
	    }
	
	    // Sort resources by resourcesCount.
	    resourcesArray.sort(sortResourcesByCount);
	    if (true) {
	      prefetcher.onNewResourcesAdded();
	    }
	
	    return true;
	  },
	  getResources: function getResources() {
	    return {
	      resourcesArray: resourcesArray,
	      resourcesCount: resourcesCount
	    };
	  },
	  getPages: function getPages() {
	    return {
	      pathArray: pathArray,
	      pathCount: pathCount
	    };
	  },
	  getPage: function getPage(pathname) {
	    return findPage(pathname);
	  },
	  has: function has(path) {
	    return pathArray.some(function (p) {
	      return p === path;
	    });
	  },
	  getResourcesForPathname: function getResourcesForPathname(path) {
	    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	    if (inInitialRender && navigator && navigator.serviceWorker && navigator.serviceWorker.controller && navigator.serviceWorker.controller.state === "activated") {
	      // If we're loading from a service worker (it's already activated on
	      // this initial render) and we can't find a page, there's a good chance
	      // we're on a new page that this (now old) service worker doesn't know
	      // about so we'll unregister it and reload.
	      if (!findPage(path)) {
	        navigator.serviceWorker.getRegistrations().then(function (registrations) {
	          // We would probably need this to
	          // prevent unnecessary reloading of the page
	          // while unregistering of ServiceWorker is not happening
	          if (registrations.length) {
	            for (var _iterator = registrations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	              var _ref;
	
	              if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	              } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	              }
	
	              var registration = _ref;
	
	              registration.unregister();
	            }
	            window.location.reload();
	          }
	        });
	      }
	    }
	    inInitialRender = false;
	    // In development we know the code is loaded already
	    // so we just return with it immediately.
	    if (false) {
	      var page = findPage(path);
	      if (!page) return cb();
	      var pageResources = {
	        component: syncRequires.components[page.componentChunkName],
	        json: syncRequires.json[page.jsonName],
	        layout: syncRequires.layouts[page.layoutComponentChunkName],
	        page: page
	      };
	      cb(pageResources);
	      return pageResources;
	      // Production code path
	    } else {
	      var _page = findPage(path);
	
	      if (!_page) {
	        console.log("A page wasn't found for \"" + path + "\"");
	        return cb();
	      }
	
	      // Use the path from the page so the pathScriptsCache uses
	      // the normalized path.
	      path = _page.path;
	
	      // Check if it's in the cache already.
	      if (pathScriptsCache[path]) {
	        process.nextTick(function () {
	          cb(pathScriptsCache[path]);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: pathScriptsCache[path]
	          });
	        });
	        return pathScriptsCache[path];
	      }
	
	      _emitter2.default.emit("onPreLoadPageResources", { path: path });
	      // Nope, we need to load resource(s)
	      var component = void 0;
	      var json = void 0;
	      var layout = void 0;
	      // Load the component/json/layout and parallel and call this
	      // function when they're done loading. When both are loaded,
	      // we move on.
	      var done = function done() {
	        if (component && json && (!_page.layoutComponentChunkName || layout)) {
	          pathScriptsCache[path] = { component: component, json: json, layout: layout, page: _page };
	          var _pageResources = { component: component, json: json, layout: layout, page: _page };
	          cb(_pageResources);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: _pageResources
	          });
	        }
	      };
	      getResourceModule(_page.componentChunkName, function (err, c) {
	        if (err) {
	          console.log("Loading the component for " + _page.path + " failed");
	        }
	        component = c;
	        done();
	      });
	      getResourceModule(_page.jsonName, function (err, j) {
	        if (err) {
	          console.log("Loading the JSON for " + _page.path + " failed");
	        }
	        json = j;
	        done();
	      });
	
	      _page.layoutComponentChunkName && getResourceModule(_page.layoutComponentChunkName, function (err, l) {
	        if (err) {
	          console.log("Loading the Layout for " + _page.path + " failed");
	        }
	        layout = l;
	        done();
	      });
	
	      return undefined;
	    }
	  },
	  peek: function peek(path) {
	    return pathArray.slice(-1)[0];
	  },
	  length: function length() {
	    return pathArray.length;
	  },
	  indexOf: function indexOf(path) {
	    return pathArray.length - pathArray.indexOf(path) - 1;
	  }
	};
	
	var publicLoader = exports.publicLoader = {
	  getResourcesForPathname: queue.getResourcesForPathname
	};
	
	exports.default = queue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(397)))

/***/ }),

/***/ 806:
/***/ (function(module, exports) {

	module.exports = [{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-introduction.json","path":"/chapter/introduction/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-evolving-europe.json","path":"/chapter/evolving-europe/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-talent.json","path":"/chapter/talent/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-community.json","path":"/chapter/community/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-capital-flows.json","path":"/chapter/capital-flows/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-deep-tech.json","path":"/chapter/deep-tech/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-corporate.json","path":"/chapter/corporate/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-regulation.json","path":"/chapter/regulation/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-success-stories-exits.json","path":"/chapter/success-stories-exits/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-mythbusting.json","path":"/chapter/mythbusting/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-whats-next.json","path":"/chapter/whats-next/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-appendix.json","path":"/chapter/appendix/"},{"componentChunkName":"component---src-templates-chapter-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-acknowledgements.json","path":"/chapter/acknowledgements/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-introduction-article-about-report.json","path":"/chapter/introduction/article/about-report/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-introduction-article-how-use-site.json","path":"/chapter/introduction/article/how-use-site/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-introduction-article-about-atomico.json","path":"/chapter/introduction/article/about-atomico/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-introduction-article-about-slush.json","path":"/chapter/introduction/article/about-slush/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-introduction-article-data-partners.json","path":"/chapter/introduction/article/data-partners/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-introduction-article-thought-leaders.json","path":"/chapter/introduction/article/thought-leaders/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-introduction-article-distribution-partners.json","path":"/chapter/introduction/article/distribution-partners/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-introduction-article-word-from-orrick.json","path":"/chapter/introduction/article/word-from-orrick/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-introduction-article-about-silicon-valley-bank.json","path":"/chapter/introduction/article/about-silicon-valley-bank/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-introduction-article-studio-lovelock-website-design.json","path":"/chapter/introduction/article/studio-lovelock-website-design/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-evolving-europe-article-its-been-busy-year-european-tech.json","path":"/chapter/evolving-europe/article/its-been-busy-year-european-tech/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-evolving-europe-article-europe-remains-bullish-about-future.json","path":"/chapter/evolving-europe/article/europe-remains-bullish-about-future/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-evolving-europe-article-macro-events-europes-tech-ecosystem.json","path":"/chapter/evolving-europe/article/macro-events-europes-tech-ecosystem/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-evolving-europe-article-european-entrepreneurs-worlds-biggest-problems.json","path":"/chapter/evolving-europe/article/european-entrepreneurs-worlds-biggest-problems/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-evolving-europe-article-european-tech-continues-diversify-geographically.json","path":"/chapter/evolving-europe/article/european-tech-continues-diversify-geographically/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-evolving-europe-article-gender-diversity-problem.json","path":"/chapter/evolving-europe/article/gender-diversity-problem-/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-talent-article-strong-pipeline-world-class-talent.json","path":"/chapter/talent/article/strong-pipeline-world-class-talent/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-talent-article-europes-tech-workforce-and-dev-population-booming.json","path":"/chapter/talent/article/europes-tech-workforce-and-dev-population-booming/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-talent-article-big-tech-giants-are-growing-presence.json","path":"/chapter/talent/article/big-tech-giants-are-growing-presence/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-talent-article-tech-talent-movement-in-europe.json","path":"/chapter/talent/article/tech-talent-movement-in-europe/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-talent-article-uk-larger-share-outbound-tech-talent-migration.json","path":"/chapter/talent/article/uk-larger-share-outbound-tech-talent-migration/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-talent-article-portrait-european-founder.json","path":"/chapter/talent/article/portrait-european-founder/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-community-article-growing-and-highly-engaged-tech-communities.json","path":"/chapter/community/article/growing-and-highly-engaged-tech-communities/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-community-article-every-european-city-becoming-tech-hub.json","path":"/chapter/community/article/every-european-city-becoming-tech-hub/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-community-article-capital-founder-mobility-links-europes-hubs.json","path":"/chapter/community/article/capital-founder-mobility-links-europes-hubs/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-capital-flows-article-another-record-year-european-tech-investment.json","path":"/chapter/capital-flows/article/another-record-year-european-tech-investment/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-capital-flows-article-deep-dive-european-tech.json","path":"/chapter/capital-flows/article/deep-dive-european-tech/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-capital-flows-article-strength-europes-tech-ecosystem-investors.json","path":"/chapter/capital-flows/article/strength-europes-tech-ecosystem-investors/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-capital-flows-article-european-vcs-deliver-strong-year-fundraising.json","path":"/chapter/capital-flows/article/european-vcs-deliver-strong-year-fundraising/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-capital-flows-article-attract-more-institutional-investors.json","path":"/chapter/capital-flows/article/attract-more-institutional-investors/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-deep-tech-article-european-deep-tech-seize-global-opportunities.json","path":"/chapter/deep-tech/article/european-deep-tech-seize-global-opportunities/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-deep-tech-article-ai-crypto-major-opportunity-europe.json","path":"/chapter/deep-tech/article/ai-crypto-major-opportunity-europe/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-deep-tech-article-europes-engineering-engaging-data-science.json","path":"/chapter/deep-tech/article/europes-engineering-engaging-data-science/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-deep-tech-article-europe-key-role-crypto-space.json","path":"/chapter/deep-tech/article/europe-key-role-crypto-space/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-deep-tech-article-europe-front-and-centre-race-in-ico-boom.json","path":"/chapter/deep-tech/article/europe-front-and-centre-race-in-ico-boom/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-corporate-article-european-tech-forge-ties-traditional-industry.json","path":"/chapter/corporate/article/european-tech-forge-ties-traditional-industry/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-corporate-article-europes-corporates-battling-defend-trillions-value.json","path":"/chapter/corporate/article/europes-corporates-battling-defend-trillions-value/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-corporate-article-patterns-flow-talent-tech-traditional-industry.json","path":"/chapter/corporate/article/patterns-flow-talent-tech-traditional-industry/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-corporate-article-europes-traditional-incumbents-hungry.json","path":"/chapter/corporate/article/europes-traditional-incumbents-hungry/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-regulation-article-regulation-viewed-barrier-scaling-european-tech.json","path":"/chapter/regulation/article/regulation-viewed-barrier-scaling-european-tech/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-regulation-article-regulation-to-become-strategic-advantage.json","path":"/chapter/regulation/article/regulation-to-become-strategic-advantage/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-success-stories-exits-article-europes-billion-dollar-success-stories.json","path":"/chapter/success-stories-exits/article/europes-billion-dollar-success-stories/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-success-stories-exits-article-europe-track-another-75-exit-value-2017.json","path":"/chapter/success-stories-exits/article/europe-track-another-75-exit-value-2017/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-success-stories-exits-article-european-tech-another-strong-year-ipos.json","path":"/chapter/success-stories-exits/article/european-tech-another-strong-year-ipos/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-mythbusting-article-european-venture-delivers-returns.json","path":"/chapter/mythbusting/article/european-venture-delivers-returns/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-mythbusting-article-european-investors-localised.json","path":"/chapter/mythbusting/article/european-investors-localised/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-mythbusting-article-european-public-market-investors-get-tech.json","path":"/chapter/mythbusting/article/european-public-market-investors-get-tech/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-whats-next-article-predictions-european-tech-2018.json","path":"/chapter/whats-next/article/predictions-european-tech-2018/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-appendix-article-survey-respondents.json","path":"/chapter/appendix/article/survey-respondents/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-appendix-article-more-about-our-data-partners.json","path":"/chapter/appendix/article/more-about-our-data-partners/"},{"componentChunkName":"component---src-templates-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"chapter-acknowledgements-article-contributors.json","path":"/chapter/acknowledgements/article/contributors/"},{"componentChunkName":"component---src-pages-404-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404.json","path":"/404/"},{"componentChunkName":"component---src-pages-cookies-js","layout":"blank","layoutComponentChunkName":"component---src-layouts-blank-js","jsonName":"cookies.json","path":"/cookies/"},{"componentChunkName":"component---src-pages-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"index.json","path":"/"},{"componentChunkName":"component---src-pages-terms-js","layout":"blank","layoutComponentChunkName":"component---src-layouts-blank-js","jsonName":"terms.json","path":"/terms/"},{"componentChunkName":"component---src-pages-404-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404-html.json","path":"/404.html"},{"componentChunkName":"component---src-pages-all-charts-index-js","layout":"blank","layoutComponentChunkName":"component---src-layouts-blank-js","jsonName":"all-charts.json","path":"/all-charts/"},{"componentChunkName":"component---src-pages-filter-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"filter-article.json","path":"/filter/article/"},{"componentChunkName":"component---src-pages-filter-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"filter.json","path":"/filter/"},{"componentChunkName":"component---src-pages-saved-article-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"saved-article.json","path":"/saved/article/"},{"componentChunkName":"component---src-pages-saved-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"saved.json","path":"/saved/"}]

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (_ref) {
	  var getNextQueuedResources = _ref.getNextQueuedResources,
	      createResourceDownload = _ref.createResourceDownload;
	
	  var pagesLoading = [];
	  var resourcesDownloading = [];
	
	  // Do things
	  var startResourceDownloading = function startResourceDownloading() {
	    var nextResource = getNextQueuedResources();
	    if (nextResource) {
	      resourcesDownloading.push(nextResource);
	      createResourceDownload(nextResource);
	    }
	  };
	
	  var reducer = function reducer(action) {
	    switch (action.type) {
	      case "RESOURCE_FINISHED":
	        resourcesDownloading = resourcesDownloading.filter(function (r) {
	          return r !== action.payload;
	        });
	        break;
	      case "ON_PRE_LOAD_PAGE_RESOURCES":
	        pagesLoading.push(action.payload.path);
	        break;
	      case "ON_POST_LOAD_PAGE_RESOURCES":
	        pagesLoading = pagesLoading.filter(function (p) {
	          return p !== action.payload.page.path;
	        });
	        break;
	      case "ON_NEW_RESOURCES_ADDED":
	        break;
	    }
	
	    // Take actions.
	    // Wait for event loop queue to finish.
	    setTimeout(function () {
	      if (resourcesDownloading.length === 0 && pagesLoading.length === 0) {
	        // Start another resource downloading.
	        startResourceDownloading();
	      }
	    }, 0);
	  };
	
	  return {
	    onResourcedFinished: function onResourcedFinished(event) {
	      // Tell prefetcher that the resource finished downloading
	      // so it can grab the next one.
	      reducer({ type: "RESOURCE_FINISHED", payload: event });
	    },
	    onPreLoadPageResources: function onPreLoadPageResources(event) {
	      // Tell prefetcher a page load has started so it should stop
	      // loading anything new
	      reducer({ type: "ON_PRE_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onPostLoadPageResources: function onPostLoadPageResources(event) {
	      // Tell prefetcher a page load has finished so it should start
	      // loading resources again.
	      reducer({ type: "ON_POST_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onNewResourcesAdded: function onNewResourcesAdded() {
	      // Tell prefetcher that more resources to be downloaded have
	      // been added.
	      reducer({ type: "ON_NEW_RESOURCES_ADDED" });
	    },
	    getState: function getState() {
	      return { pagesLoading: pagesLoading, resourcesDownloading: resourcesDownloading };
	    },
	    empty: function empty() {
	      pagesLoading = [];
	      resourcesDownloading = [];
	    }
	  };
	};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _apiRunnerBrowser = __webpack_require__(283);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(99);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouterDom = __webpack_require__(223);
	
	var _gatsbyReactRouterScroll = __webpack_require__(726);
	
	var _domready = __webpack_require__(592);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _history = __webpack_require__(443);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _emitter = __webpack_require__(243);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _pages = __webpack_require__(806);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _redirects = __webpack_require__(807);
	
	var _redirects2 = _interopRequireDefault(_redirects);
	
	var _componentRenderer = __webpack_require__(441);
	
	var _componentRenderer2 = _interopRequireDefault(_componentRenderer);
	
	var _asyncRequires = __webpack_require__(440);
	
	var _asyncRequires2 = _interopRequireDefault(_asyncRequires);
	
	var _loader = __webpack_require__(339);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (true) {
	  __webpack_require__(578);
	}
	
	window.___emitter = _emitter2.default;
	
	_loader2.default.addPagesArray(_pages2.default);
	_loader2.default.addProdRequires(_asyncRequires2.default);
	window.asyncRequires = _asyncRequires2.default;
	window.___loader = _loader2.default;
	window.matchPath = _reactRouterDom.matchPath;
	
	// Convert to a map for faster lookup in maybeRedirect()
	var redirectMap = _redirects2.default.reduce(function (map, redirect) {
	  map[redirect.fromPath] = redirect;
	  return map;
	}, {});
	
	var maybeRedirect = function maybeRedirect(pathname) {
	  var redirect = redirectMap[pathname];
	
	  if (redirect != null) {
	    _history2.default.replace(redirect.toPath);
	    return true;
	  } else {
	    return false;
	  }
	};
	
	// Check for initial page-load redirect
	maybeRedirect(window.location.pathname);
	
	// Let the site/plugins run code very early.
	(0, _apiRunnerBrowser.apiRunnerAsync)("onClientEntry").then(function () {
	  // Let plugins register a service worker. The plugin just needs
	  // to return true.
	  if ((0, _apiRunnerBrowser.apiRunner)("registerServiceWorker").length > 0) {
	    __webpack_require__(447);
	  }
	
	  var navigateTo = function navigateTo(pathname) {
	    var redirect = redirectMap[pathname];
	
	    // If we're redirecting, just replace the passed in pathname
	    // to the one we want to redirect to.
	    if (redirect) {
	      pathname = redirect.toPath;
	    }
	
	    // If we're already at this path, do nothing.
	    if (window.location.pathname === pathname) {
	      return;
	    }
	
	    // Listen to loading events. If page resources load before
	    // a second, navigate immediately.
	    function eventHandler(e) {
	      if (e.page.path === _loader2.default.getPage(pathname).path) {
	        _emitter2.default.off("onPostLoadPageResources", eventHandler);
	        clearTimeout(timeoutId);
	        window.___history.push(pathname);
	      }
	    }
	
	    // Start a timer to wait for a second before transitioning and showing a
	    // loader in case resources aren't around yet.
	    var timeoutId = setTimeout(function () {
	      _emitter2.default.off("onPostLoadPageResources", eventHandler);
	      _emitter2.default.emit("onDelayedLoadPageResources", { pathname: pathname });
	      window.___history.push(pathname);
	    }, 1000);
	
	    if (_loader2.default.getResourcesForPathname(pathname)) {
	      // The resources are already loaded so off we go.
	      clearTimeout(timeoutId);
	      window.___history.push(pathname);
	    } else {
	      // They're not loaded yet so let's add a listener for when
	      // they finish loading.
	      _emitter2.default.on("onPostLoadPageResources", eventHandler);
	    }
	  };
	
	  // window.___loadScriptsForPath = loadScriptsForPath
	  window.___navigateTo = navigateTo;
	
	  // Call onRouteUpdate on the initial page load.
	  (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", {
	    location: _history2.default.location,
	    action: _history2.default.action
	  });
	
	  function attachToHistory(history) {
	    if (!window.___history) {
	      window.___history = history;
	
	      history.listen(function (location, action) {
	        if (!maybeRedirect(location.pathname)) {
	          (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", { location: location, action: action });
	        }
	      });
	    }
	  }
	
	  function shouldUpdateScroll(prevRouterProps, _ref) {
	    var pathname = _ref.location.pathname;
	
	    var results = (0, _apiRunnerBrowser.apiRunner)("shouldUpdateScroll", {
	      prevRouterProps: prevRouterProps,
	      pathname: pathname
	    });
	    if (results.length > 0) {
	      return results[0];
	    }
	
	    if (prevRouterProps) {
	      var oldPathname = prevRouterProps.location.pathname;
	
	      if (oldPathname === pathname) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  var AltRouter = (0, _apiRunnerBrowser.apiRunner)("replaceRouterComponent", { history: _history2.default })[0];
	  var DefaultRouter = function DefaultRouter(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	      _reactRouterDom.Router,
	      { history: _history2.default },
	      children
	    );
	  };
	
	  var ComponentRendererWithRouter = (0, _reactRouterDom.withRouter)(_componentRenderer2.default);
	
	  _loader2.default.getResourcesForPathname(window.location.pathname, function () {
	    var Root = function Root() {
	      return (0, _react.createElement)(AltRouter ? AltRouter : DefaultRouter, null, (0, _react.createElement)(_gatsbyReactRouterScroll.ScrollContext, { shouldUpdateScroll: shouldUpdateScroll }, (0, _react.createElement)(ComponentRendererWithRouter, {
	        layout: true,
	        children: function children(layoutProps) {
	          return (0, _react.createElement)(_reactRouterDom.Route, {
	            render: function render(routeProps) {
	              attachToHistory(routeProps.history);
	              var props = layoutProps ? layoutProps : routeProps;
	
	              if (_loader2.default.getPage(props.location.pathname)) {
	                return (0, _react.createElement)(_componentRenderer2.default, _extends({
	                  page: true
	                }, props));
	              } else {
	                return (0, _react.createElement)(_componentRenderer2.default, {
	                  page: true,
	                  location: { pathname: "/404.html" }
	                });
	              }
	            }
	          });
	        }
	      })));
	    };
	
	    var NewRoot = (0, _apiRunnerBrowser.apiRunner)("wrapRootComponent", { Root: Root }, Root)[0];
	    (0, _domready2.default)(function () {
	      return _reactDom2.default.render(_react2.default.createElement(NewRoot, null), typeof window !== "undefined" ? document.getElementById("___gatsby") : void 0, function () {
	        (0, _apiRunnerBrowser.apiRunner)("onInitialClientRender");
	      });
	    });
	  });
	});

/***/ }),

/***/ 807:
/***/ (function(module, exports) {

	module.exports = []

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _emitter = __webpack_require__(243);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__ + "/";
	}
	
	if ("serviceWorker" in navigator) {
	  navigator.serviceWorker.register(pathPrefix + "sw.js").then(function (reg) {
	    reg.addEventListener("updatefound", function () {
	      // The updatefound event implies that reg.installing is set; see
	      // https://w3c.github.io/ServiceWorker/#service-worker-registration-updatefound-event
	      var installingWorker = reg.installing;
	      console.log("installingWorker", installingWorker);
	      installingWorker.addEventListener("statechange", function () {
	        switch (installingWorker.state) {
	          case "installed":
	            if (navigator.serviceWorker.controller) {
	              // At this point, the old content will have been purged and the fresh content will
	              // have been added to the cache.
	              // We reload immediately so the user sees the new content.
	              // This could/should be made configurable in the future.
	              window.location.reload();
	            } else {
	              // At this point, everything has been precached.
	              // It's the perfect time to display a "Content is cached for offline use." message.
	              console.log("Content is now available offline!");
	              _emitter2.default.emit("sw:installed");
	            }
	            break;
	
	          case "redundant":
	            console.error("The installing service worker became redundant.");
	            break;
	        }
	      });
	    });
	  }).catch(function (e) {
	    console.error("Error during service worker registration:", e);
	  });
	}

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(223);
	
	var _reactRedux = __webpack_require__(6);
	
	var _store = __webpack_require__(501);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.replaceRouterComponent = function (_ref) {
	  var history = _ref.history;
	
	  var ConnectedRouterWrapper = function ConnectedRouterWrapper(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(
	        _reactRouterDom.Router,
	        { history: history },
	        children
	      )
	    );
	  };
	
	  return ConnectedRouterWrapper;
	};

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* global document: false, __webpack_require__: false */
	patch();
	
	function patch() {
	  var head = document.querySelector("head");
	  var ensure = __webpack_require__.e;
	  var chunks = __webpack_require__.s;
	  var failures;
	
	  __webpack_require__.e = function (chunkId, callback) {
	    var loaded = false;
	    var immediate = true;
	
	    var handler = function handler(error) {
	      if (!callback) return;
	
	      callback(__webpack_require__, error);
	      callback = null;
	    };
	
	    if (!chunks && failures && failures[chunkId]) {
	      handler(true);
	      return;
	    }
	
	    ensure(chunkId, function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (immediate) {
	        // webpack fires callback immediately if chunk was already loaded
	        // IE also fires callback immediately if script was already
	        // in a cache (AppCache counts too)
	        setTimeout(function () {
	          handler();
	        });
	      } else {
	        handler();
	      }
	    });
	
	    // This is |true| if chunk is already loaded and does not need onError call.
	    // This happens because in such case ensure() is performed in sync way
	    if (loaded) {
	      return;
	    }
	
	    immediate = false;
	
	    onError(function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (chunks) {
	        chunks[chunkId] = void 0;
	      } else {
	        failures || (failures = {});
	        failures[chunkId] = true;
	      }
	
	      handler(true);
	    });
	  };
	
	  function onError(callback) {
	    var script = head.lastChild;
	
	    if (script.tagName !== "SCRIPT") {
	      if (typeof console !== "undefined" && console.warn) {
	        console.warn("Script is not a script", script);
	      }
	
	      return;
	    }
	
	    script.onload = script.onerror = function () {
	      script.onload = script.onerror = null;
	      setTimeout(callback, 0);
	    };
	  }
	}

/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(516);
	
	__webpack_require__(517);

/***/ }),

/***/ 871:
/***/ (function(module, exports) {

	function n(n){return n=n||Object.create(null),{on:function(t,o){(n[t]||(n[t]=[])).push(o)},off:function(t,o){n[t]&&n[t].splice(n[t].indexOf(o)>>>0,1)},emit:function(t,o){(n[t]||[]).map(function(n){n(o)}),(n["*"]||[]).map(function(n){n(t,o)})}}}module.exports=n;
	//# sourceMappingURL=mitt.js.map

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var compose = __webpack_require__(224).compose;
	
	exports.__esModule = true;
	exports.composeWithDevTools = (
	   false ?
	    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
	    function() {
	      if (arguments.length === 0) return undefined;
	      if (typeof arguments[0] === 'object') return compose;
	      return compose.apply(null, arguments);
	    }
	);
	
	exports.devToolsEnhancer = (
	   false ?
	    window.__REDUX_DEVTOOLS_EXTENSION__ :
	    function() { return function(noop) { return noop; } }
	);


/***/ }),

/***/ 946:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.onRouteUpdate = function (_ref) {
	  var location = _ref.location;
	
	  // Don't track while developing.
	  if (("production") === "production" && typeof ga === "function") {
	    window.ga("set", "page", (location || {}).pathname);
	    window.ga("send", "pageview");
	  }
	};

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(162898551421021, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(490) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(74507423614034, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(491) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(146646658547335, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(492) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(162301028415776, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(493) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(53243946022428, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(494) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(35783957827783, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(495) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(170819979320109, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(496) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(277786696673472, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(497) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(267695594480457, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(498) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.articlesReducer = undefined;
	
	var _redux = __webpack_require__(224);
	
	var _save = __webpack_require__(81);
	
	var _filter = __webpack_require__(247);
	
	var articlesReducer = exports.articlesReducer = (0, _redux.combineReducers)({
	  filter: _filter.filterReducer,
	  save: _save.saveReducer
	});

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.rehydrate = exports.clearCookieNotice = exports.setCookieNotice = exports.getCookieNotice = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.cookieNoticeReducer = cookieNoticeReducer;
	
	var _storage = __webpack_require__(249);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var typePrefix = "cookieNotice/";
	var CLEAR = typePrefix + "CLEAR";
	var SET = typePrefix + "SET";
	
	// Selectors
	
	var getCookieNotice = exports.getCookieNotice = function getCookieNotice(state) {
	  return state.cookieNotice.cookieNotice;
	};
	
	// Action creators
	
	/**
	 *
	 * @param {string} articleId the article Id to be toggled
	 * @return {function} thunk action creator
	 */
	var setCookieNotice = exports.setCookieNotice = function setCookieNotice() {
	  return function (dispatch) {
	    dispatch({ type: SET });
	    var serialised = JSON.stringify({ cookieNotice: true });
	    _storage2.default.setItem(typePrefix, serialised);
	  };
	};
	
	var clearCookieNotice = exports.clearCookieNotice = function clearCookieNotice() {
	  return function (dispatch) {
	    dispatch({ type: CLEAR });
	    var serialised = JSON.stringify(emptyState);
	    _storage2.default.setItem(typePrefix, serialised);
	  };
	};
	
	var emptyState = {
	  cookieNotice: false
	};
	
	/**
	 * Rehydrate the state from storage.
	 * @return {object} Previously saved auth state or an empty object
	 */
	var rehydrate = exports.rehydrate = function rehydrate() {
	  var cookieNotice = _storage2.default.getItem(typePrefix);
	  var hydrated = typeof cookieNotice === "string" ? JSON.parse(cookieNotice) : emptyState;
	  return hydrated;
	};
	
	// Reducer
	function cookieNoticeReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rehydrate();
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET:
	      return {
	        cookieNotice: true
	      };
	    case CLEAR:
	      return _extends({}, emptyState);
	    default:
	      return state;
	  }
	}

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.rootReducer = undefined;
	
	var _redux = __webpack_require__(224);
	
	var _articles = __webpack_require__(499);
	
	var _chart = __webpack_require__(285);
	
	var _cookieNotice = __webpack_require__(344);
	
	var _modal = __webpack_require__(20);
	
	var _navSection = __webpack_require__(33);
	
	var _previewScroll = __webpack_require__(65);
	
	var _user = __webpack_require__(125);
	
	/**
	 * Composes all top-level reducers.
	 */
	
	var rootReducer = exports.rootReducer = (0, _redux.combineReducers)({
	  articles: _articles.articlesReducer,
	  chart: _chart.chartReducer,
	  cookieNotice: _cookieNotice.cookieNoticeReducer,
	  modal: _modal.modalReducer,
	  navSection: _navSection.navSectionReducer,
	  previewScroll: _previewScroll.previewScrollReducer,
	  user: _user.userReducer
	});

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _redux = __webpack_require__(224);
	
	var _developmentOnly = __webpack_require__(945);
	
	var _reduxThunk = __webpack_require__(946);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _state = __webpack_require__(500);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This array of strings as regex defines which actions are blacklisted from
	 * both logging on Redux DevTools.
	 */
	var actionsBlacklist = [];
	
	var middleware = [_reduxThunk2.default];
	
	var composeEnhancers = (0, _developmentOnly.composeWithDevTools)({
	  maxAge: 200,
	  actionsBlacklist: actionsBlacklist
	});
	
	var store = (0, _redux.createStore)(_state.rootReducer, composeEnhancers(_redux.applyMiddleware.apply(undefined, middleware)));
	
	// sagas.run(rootSaga);
	
	if (false) {
	  module.hot.accept("./state", function () {
	    // eslint-disable-next-line global-require
	    var nextRootReducer = require("./state/index").rootReducer;
	    store.replaceReducer(nextRootReducer);
	  });
	}
	
	exports.default = store;
	module.exports = exports["default"];

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(131683993344931, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(502) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      3
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(164721891013254, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(503) })
	        }
	      });
	     }
	    

/***/ })

});


// WEBPACK FOOTER //
// app-b271aa9af00b757623a9.js